<template>
    <div class="p-0">
        <div v-if="entrada === false && salida === false && evidencia === false">
            <div class="row pb-2">
                <span>{{ empresa }}</span>
            </div>
            <div class="row pb-2">
                <span>{{ numeroEmpleado }} {{ nombreEmpleado }}</span>
            </div>
            <div class="d-grid pt-3" v-if="$localStorageService.can('api.REGISTRO_ASISTENCIA')">
                <button type="button" class="btn btn-success btn-lg px-4 me-sm-3" id="entradaButton" @click="cambiarVista(1)">
                    Entrada
                </button>
            </div>
            <div class="d-grid pt-3" v-if="$localStorageService.can('api.REGISTRO_ASISTENCIA')">
                <button type="button" class="btn btn-secondary btn-lg px-4 me-sm-3" id="salidaButton" @click="cambiarVista(2)">
                    Salida
                </button>
            </div>
            <div class="d-grid pt-3" v-if="$localStorageService.can('api.REGISTRO_EVIDENCIA')">
                <button type="button" class="btn btn-warning btn-lg px-4 me-sm-3" id="evidenciaButton" @click="cambiarVista(3)">
                    Evidencia
                </button>
            </div>
        </div>
        <div v-else>
<!--            <div align="center">-->
<!--                <button type="button" class="btn btn-secondary btn-lg px-4 me-sm-3" id="regresarButton"  @click="cambiarVista(0)">-->
<!--                    {{titulo}}-->
<!--                </button>-->
<!--            </div>-->
            <CheckComponent v-if="evidencia === false" :titulo="titulo"/>
            <EvidenciaComponent v-else/>
        </div>
    </div>
</template>
<script>
import CheckComponent from './Check-Component.vue';
import EvidenciaComponent from './Evidencia-Component.vue';
import {inject} from "vue";
import {DashboardService} from "@/services/DashboardService";
export default {
    name: 'Perfil-componente',
    inject: ['$axios', '$localStorageService', 'inject'],
    components: { CheckComponent, EvidenciaComponent },
    setup() {
        return {
            srv_dashboardService: new DashboardService( inject('$axios')),
        }
    },
    data() {
        return {
            empresa: null,
            idEmplado: null,
            nombreEmpleado: null,
            mostrar: false,
            titulo: "",
            entrada: false,
            salida: false,
            evidencia: false,
            filtros: {
                rango: [
                    new Date(new Date().toDateString()),
                    new Date(new Date().toDateString())
                ]
            },
        }
    },

    mounted() {
        this.obtenerEmpresa();
        if (this.$localStorageService.isAuth()) {
            this.numeroEmpleado = this.$localStorageService.getNumEmpleado();
            this.nombreEmpleado = this.$localStorageService.getNombreCompleto();
        }/*else{
            this.$router.push({ name: 'login' });
        }*/
    },

    methods: {
        cambiarVista(vista){
            if(vista === 1){
                this.entrada = true;
                this.salida = false;
                this.evidencia = false;
                this.titulo = "Entradas";
            }else if (vista === 2){
                this.entrada = false;
                this.salida = true;
                this.evidencia = false;
                this.titulo = "Salidas";
            }else if(vista === 3){
                this.entrada = false;
                this.salida = false;
                this.evidencia = true;
                this.titulo = "Evidencia";
            }else{
                this.entrada = false;
                this.salida = false;
                this.evidencia = false;
                this.titulo = "";
            }
        },

        obtenerEmpresa(){
            let load = this.$loading.show({
                container: this.$refs.formContainer,//puede ponerse null
                canCancel: true,
                onCancel: this.onCancelLoader,
            });
            this.srv_dashboardService.obtenerReporte(this.filtros.rango[0], this.filtros.rango[1]).then((response)=>{
               response.plantilla.forEach(empresa=>{
                if(empresa[5] === this.nombreEmpleado){
                    this.empresa = empresa[0] + "/" + empresa[1];
                    this.$localStorageService.setEmpresaEmpleado(this.empresa);
                }
               })
            }).finally(()=>load.hide());
        },
    }
}
</script>
<style>
body{
    background-color: black;
    color: white;
}
</style>